
import { MfaChallenge, RegistrationFormValues } from './types';

export const transformToRequestRegister = (
  formValues: RegistrationFormValues
): any => {
  return {
    tenantType: formValues.tenantType,
    firstName: formValues.firstName ?? "",
    lastName: formValues.lastName ?? "",
    companyName: formValues.companyName ?? "",
    taxNumber: formValues.taxNumber ?? "",
    email: formValues.email,
    password: formValues.password,
  };
};

export const transformMfaChallenge = (res: any): MfaChallenge => ({
  challengeId: res.challengeId,
  email: res.email ?? "",
  expiresAt: res.expiresAt,
  resendAvailableAt: res.resendAvailableAt,
});
